import { useTranslations } from '@vocab/react';
import { Dialog, Text, Actions, Button, IconDelete } from 'braid-design-system';

import translations from './DeleteDialog.vocab';

interface Props {
  index: number;
  showDeleteDialog: boolean;
  setShowDeleteDialog: (flag: boolean) => void;
  processDelete: () => void;
  title: string;
  message: string;
}

export const DeleteDialog = ({
  index,
  showDeleteDialog,
  setShowDeleteDialog,
  processDelete,
  title,
  message,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      id={`dialog-delete-${index}`}
      title={title}
      open={showDeleteDialog}
      onClose={() => setShowDeleteDialog(false)}
      closeLabel={t('Close')}
      width="xsmall"
    >
      <Text>{message}</Text>
      <Actions>
        <Button
          id={`dialog-delete-button-${index}`}
          tone="critical"
          variant="solid"
          icon={<IconDelete />}
          onClick={processDelete}
        >
          {t('Delete')}
        </Button>
        <Button
          id={`dialog-delete-cancel-button-${index}`}
          tone="formAccent"
          variant="transparent"
          onClick={() => setShowDeleteDialog(false)}
        >
          {t('Cancel')}
        </Button>
      </Actions>
    </Dialog>
  );
};
